import { Action } from '@ngrx/store';

import { CampaignOutputApiModel } from '../models/api-models/output';
import { ResponsePaginationApiModel } from '@framework/models';
import { GetCampaignInputApiModel } from '../models/api-models/input';


export enum ActionTypes {
    LOAD = '[Company Admin Campaign] Load',
    LOAD_SUCCESS = '[Company Admin Campaign] Load Success',
    LOAD_FAIL = '[Company Admin Campaign] Load Fail',

    MAKE_ACTIVE = '[Company Admin Campaign] Make Active',
    MAKE_ACTIVE_SUCCESS = '[Company Admin Campaign] Make Active Success',
    MAKE_ACTIVE_FAIL = '[Company Admin Campaign] Make Active Fail',

    MAKE_INACTIVE = '[Company Admin Campaign] Make Inactive',
    MAKE_INACTIVE_SUCCESS = '[Company Admin Campaign] Make Inactive Success',
    MAKE_INACTIVE_FAIL = '[Company Admin Campaign] Make Inactive Fail',

    TURN_PUBLIC_OFF = '[Company Admin Campaign] Turn Public Off',
    TURN_PUBLIC_OFF_SUCCESS = '[Company Admin Campaign] Turn Public Off Success',
    TURN_PUBLIC_OFF_FAIL = '[Company Admin Campaign] Turn Public Off Fail',

    TURN_PUBLIC_ON = '[Company Admin Campaign] Turn Public On',
    TURN_PUBLIC_ON_SUCCESS = '[Company Admin Campaign] Turn Public On Success',
    TURN_PUBLIC_ON_FAIL = '[Company Admin Campaign] Turn Public On Fail'
}

export class Load implements Action {
    readonly type = ActionTypes.LOAD;

    constructor(public companyId: number, public queryData: GetCampaignInputApiModel) { }
}

export class LoadSuccess implements Action {
    readonly type = ActionTypes.LOAD_SUCCESS;

    constructor(public response: ResponsePaginationApiModel<CampaignOutputApiModel>) { }
}

export class LoadFail implements Action {
    readonly type = ActionTypes.LOAD_FAIL;

    constructor(public error: any) { }
}

export class MakeInactive implements Action {
    readonly type = ActionTypes.MAKE_INACTIVE;

    constructor(public companyId: number, public ids: number[]) { }
}

export class MakeInactiveSuccess implements Action {
    readonly type = ActionTypes.MAKE_INACTIVE_SUCCESS;
}

export class MakeInactiveFail implements Action {
    readonly type = ActionTypes.MAKE_INACTIVE_FAIL;

    constructor(public error: any) { }
}

export class MakeActive implements Action {
    readonly type = ActionTypes.MAKE_ACTIVE;

    constructor(public companyId: number, public ids: number[]) { }
}

export class MakeActiveSuccess implements Action {
    readonly type = ActionTypes.MAKE_ACTIVE_SUCCESS;
}

export class MakeActiveFail implements Action {
    readonly type = ActionTypes.MAKE_ACTIVE_FAIL;

    constructor(public error: any) { }
}

export class TurnPublicOn implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_ON;

    constructor(public companyId: number, public ids: number[]) { }
}

export class TurnPublicOnSuccess implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_ON_SUCCESS;

    constructor(public ids: number[]) { }
}

export class TurnPublicOnFail implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_ON_FAIL;

    constructor(public error: any, public ids: number[] = []) { }
}

export class TurnPublicOff implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_OFF;

    constructor(public companyId: number, public ids: number[]) { }
}

export class TurnPublicOffSuccess implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_OFF_SUCCESS;

    constructor(public ids: number[]) { }
}

export class TurnPublicOffFail implements Action {
    readonly type = ActionTypes.TURN_PUBLIC_OFF_FAIL;

    constructor(public error: any, public ids: number[] = []) { }
}

export type Actions =
    Load | LoadSuccess | LoadFail |
    MakeActive | MakeActiveSuccess | MakeActiveFail |
    MakeInactive | MakeInactiveSuccess | MakeInactiveFail |
    TurnPublicOn | TurnPublicOnSuccess | TurnPublicOnFail |
    TurnPublicOff | TurnPublicOffSuccess | TurnPublicOffFail;
